var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.48,
    height: 18.48,
    viewBox: "0 0 18.48 18.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notes",
    transform: "translate(23.601 23.906) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New_Report",
    "data-name": "New Report",
    transform: "translate(-10705.679 55.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52930",
    "data-name": "Path 52930",
    d: "M22.91,7H9.17A2.17,2.17,0,0,0,7,9.17V22.91a2.17,2.17,0,0,0,2.17,2.17H22.91a2.17,2.17,0,0,0,2.17-2.17V9.17A2.17,2.17,0,0,0,22.91,7Zm.723,15.91a.723.723,0,0,1-.723.723H9.17a.723.723,0,0,1-.723-.723V9.17a.723.723,0,0,1,.723-.723H22.91a.723.723,0,0,1,.723.723Z",
    transform: "translate(10704 -57)",
    fill: "#f45e29",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52931",
    "data-name": "Path 52931",
    d: "M27.955,23.616H25.062V20.723a.723.723,0,1,0-1.446,0v2.893H20.723a.723.723,0,1,0,0,1.446h2.893v2.893a.723.723,0,0,0,1.446,0V25.062h2.893a.723.723,0,0,0,0-1.446Z",
    transform: "translate(10695.701 -65.299)",
    fill: "#f45e29",
    stroke: "#fff",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddSquare);
export default __webpack_public_path__ + "static/media/icon-add-square.60ec82b8.svg";
export { ForwardRef as ReactComponent };